import type { Components, Theme } from "@mui/material";

export const covestroMuiFormHelperText: Components<Theme>["MuiFormHelperText"] =
  {
    styleOverrides: {
      root: ({ theme }) => ({
        marginLeft: theme.spacing(0.5),
        marginRight: theme.spacing(0.5),
      }),
    },
  };
